import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  withRouter,
  getQueryParam,
  setQueryParam,
} from '../../../../common/utils/NavigationWrapper';
import moment from 'moment';
import { Timeline as ChartIcon } from '@mui/icons-material';

import { IconButton, Button } from '@mui/material';

import { getInstrumentData } from './InstrumentTelemetry.actions';
import InstrumentTelemetry from './InstrumentTelemetry';
import Utils from '../../../../common/utils/Utils';
import Constants from '../../../../common/constants/Constants';
import Store from '../../../../redux/Store';
import { setGlobalDateTime } from '../../../../common/state/datetime/DateTime.actions';
import { SET_GLOBAL_DATETIME } from '../../../../common/state/datetime/DateTime.types';
import { connect } from 'react-redux';

const defaultState = (props) => ({
  isFetching: true,
  selectedTableFilter: props.selectedTable,
  dateTimeFromFilter:
    !props.selectedTable || props.selectedTable.reportName !== 'Events'
      ? Utils.NowAsUtcFe().subtract(6, 'd')
      : Utils.NowAsUtcFe().subtract(7, 'd'),
  dateTimeToFilter:
    !props.selectedTable || props.selectedTable.reportName !== 'Events'
      ? Utils.NowAsUtcFe().add(1, 'd')
      : Utils.NowAsUtcFe(),
  timeRangeMessage: null,
  chartData: {},
  navigatorData: null,
  tableConfig: [],
  tableData: [],
  metadata: {},
  subreportConfig: { dialogSubreport: { open: false } },
  showTableFilter: props.reports.length > 1,
  activeTimeGran: moment.duration(7, 'day').asMinutes(),
  dateTimeErrorMessage: null,
  extraActionsButtons: null,
  exportRawDataReport: null,
});

class InstrumentTelemetryContainer extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState(props);

    this._onChangeDateTime = this._onChangeDateTime.bind(this);
    this._getNewTimeGran = this._getNewTimeGran.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (
      (newProps.selectedTable != null &&
        newProps.selectedTable.reportName != this.props.selectedTable.reportName) ||
      newProps.instrument.SerialNumber != this.props.instrument.SerialNumber
    ) {
      let [dateTimeFrom, dateTimeTo, table] = this._getQueryValues(newProps);
      let savedReport = null;

      if (this.props.globalDateTime != null && this.props.globalDateTime.startDate != undefined) {
        dateTimeFrom = moment.utc(this.props.globalDateTime.startDate);
        dateTimeTo = moment.utc(this.props.globalDateTime.endDate);
        savedReport = this._getReportByName(this.props.globalDateTime.setByReportName);
      }

      if (savedReport == null) {
        savedReport = newProps.selectedTable;
      }

      const newTable = table == null ? savedReport : this._getReportByName(table);

      const newDateTimeFrom = this._determinePropertyValue(dateTimeFrom, 'dateTimeFromFilter');
      const newDateTimeTo = this._determinePropertyValue(dateTimeTo, 'dateTimeToFilter');

      let dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateTimeFrom, newDateTimeTo);

      let newTimeGran = this._getNewTimeGran(
        moment.utc(newDateTimeFrom),
        moment.utc(newDateTimeTo),
        null,
        dateTimeErrorMessage
      );

      let newState = {
        ...defaultState(newProps),
        selectedTableFilter: newTable,
        dateTimeFromFilter: newDateTimeFrom,
        dateTimeToFilter: newDateTimeTo,
        activeTimeGran: newTimeGran,
        dateTimeErrorMessage,
      };

      this.setState(() => newState, this._onApplyFilters);
    }
  }

  componentDidMount() {
    let [dateTimeFrom, dateTimeTo, table] = this._getQueryValues(this.props);

    if (this.props.globalDateTime != null && this.props.globalDateTime.startDate != undefined) {
      dateTimeFrom = moment.utc(this.props.globalDateTime.startDate);
      dateTimeTo = moment.utc(this.props.globalDateTime.endDate);
      table = this.props.selectedTable.displayName;
    }

    const newDateTimeFrom = this._determinePropertyValue(dateTimeFrom, 'dateTimeFromFilter');
    const newDateTimeTo = this._determinePropertyValue(dateTimeTo, 'dateTimeToFilter');

    let dateTimeErrorMessage = this._checkDateTimeCorrectness(newDateTimeFrom, newDateTimeTo);

    let newTimeGran = this._getNewTimeGran(
      moment.utc(newDateTimeFrom),
      moment.utc(newDateTimeTo),
      null,
      dateTimeErrorMessage
    );

    this.setState(
      {
        selectedTableFilter: this._determinePropertyValue(table, 'selectedTableFilter'),
        dateTimeFromFilter: newDateTimeFrom,
        dateTimeToFilter: newDateTimeTo,
        activeTimeGran: newTimeGran,
        dateTimeErrorMessage,
      },
      () => {
        this._onApplyFilters();
      }
    );
  }

  render() {
    return (
      <InstrumentTelemetry
        tableFilterList={this.props.reports}
        isFetching={this.state.isFetching}
        selectedTableFilter={this.state.selectedTableFilter}
        showTableFilter={this.state.showTableFilter}
        onChangeSourceTable={this._onChangeSourceTable}
        dateTimeFromFilter={this.state.dateTimeFromFilter}
        dateTimeToFilter={this.state.dateTimeToFilter}
        onChangeDateTime={this._onChangeDateTime}
        timeRangeMessage={this.state.timeRangeMessage}
        onApplyFilters={this._onApplyFilters}
        chartData={this.state.chartData}
        navigatorConfig={this.state.navigatorData}
        tableData={this.state.tableData}
        tableConfig={this.state.tableConfig}
        exportRawDataReport={this.state.exportRawDataReport}
        metadata={this.state.metadata}
        subreportConfig={this.state.subreportConfig}
        currentReportName={this.state.currentReportName}
        instrument={this.props.instrument}
        activeTimeGran={this.state.activeTimeGran}
        dateTimeErrorMessage={this.state.dateTimeErrorMessage}
        extraActionsButtons={this.state.extraActionsButtons}
      />
    );
  }

  _getQueryValues = (props) => {
    const dateTimeFrom = getQueryParam(
      'dateTimeFrom',
      'customDateTimeType',
      props.querySearchParams
    );
    const dateTimeTo = getQueryParam('dateTimeTo', 'customDateTimeType', props.querySearchParams);
    const table = getQueryParam('table', 'string', props.querySearchParams);

    return [dateTimeFrom, dateTimeTo, table];
  };

  _setQueryValues = (newDateFrom, newDateTo, newTable) => {
    let newQueryParams = [
      {
        value: newDateFrom,
        key: 'dateTimeFrom',
        type: 'customDateTimeType',
      },
      {
        value: newDateTo,
        key: 'dateTimeTo',
        type: 'customDateTimeType',
      },
      {
        value: newTable,
        key: 'table',
        type: 'string',
      },
    ];

    setQueryParam(newQueryParams, this.props.querySearchParams, this.props.setQuerySearchParams);
  };

  _determinePropertyValue = (propertyValue, propertyNameInState) => {
    return propertyValue != null
      ? propertyNameInState == 'selectedTableFilter'
        ? propertyValue == 'Events'
          ? this.props.selectedTable
          : this._getReportByName(propertyValue)
        : propertyValue
      : this.state[propertyNameInState];
  };

  _getReportByName = (reportNameToSearch) => {
    let selectedReport = '';
    this.props.reports.forEach(function (report) {
      if (report.displayName == reportNameToSearch) {
        selectedReport = report;
      }
    });

    return selectedReport;
  };

  _onChangeSourceTable = (index) => {
    let selectedTableFilter = this.props.reports[index];
    let dateTimeFromFilter, dateTimeToFilter;
    let setDefaultDates = false;

    if (this.props.globalDateTime != null && this.props.globalDateTime.startDate != undefined) {
      dateTimeFromFilter = moment.utc(this.props.globalDateTime.startDate);
      dateTimeToFilter = moment.utc(this.props.globalDateTime.endDate);
    } else {
      setDefaultDates = true;
      dateTimeFromFilter = moment.utc();
      dateTimeToFilter = moment.utc(dateTimeFromFilter);
    }

    if (setDefaultDates) {
      if (selectedTableFilter.dateRange) {
        dateTimeFromFilter = moment
          .utc(dateTimeFromFilter)
          .subtract(selectedTableFilter.dateRange.value, selectedTableFilter.dateRange.units); // custom time window for filters;
      } else {
        dateTimeFromFilter = moment.utc(dateTimeFromFilter).subtract(168, 'hours'); // default time window for filters
      }
    }

    if (selectedTableFilter.extendEndDate) {
      dateTimeToFilter = dateTimeToFilter.startOf('day').add(1, 'day');
      dateTimeFromFilter = dateTimeFromFilter.startOf('day').add(1, 'day');
    }

    let newDateTimeRange = this._getNearestTimeRange(
      dateTimeFromFilter,
      dateTimeToFilter,
      selectedTableFilter
    );

    let dateTimeErrorMessage = this._checkDateTimeCorrectness(
      newDateTimeRange.nearestDateTimeFrom,
      newDateTimeRange.nearestDateTimeTo
    );

    let newTimeGran = this._getNewTimeGran(
      newDateTimeRange.nearestDateTimeFrom,
      newDateTimeRange.nearestDateTimeTo,
      null,
      dateTimeErrorMessage
    );

    this.setState(
      {
        selectedTableFilter,
        dateTimeFromFilter: newDateTimeRange.nearestDateTimeFrom,
        dateTimeToFilter: newDateTimeRange.nearestDateTimeTo,
        timeRangeMessage: this._getTimeRangeMessage(newDateTimeRange),
        navigatorData: null,
        activeTimeGran: newTimeGran,
        dateTimeErrorMessage,
      },
      () => {
        this._setQueryValues(
          this.state.dateTimeFromFilter,
          this.state.dateTimeToFilter,
          selectedTableFilter.displayName
        );
      }
    );
  };

  _getNewTimeGran = (dateFrom, dateTo, timeGranFromChart, dateTimeErrorMessage) => {
    let newTimeGran = null;

    if (timeGranFromChart != null) return timeGranFromChart;

    if (timeGranFromChart == null && dateTimeErrorMessage == null) {
      if (dateFrom.isSame(dateTo)) {
        newTimeGran = moment.duration(1, 'minutes');
      } else {
        newTimeGran = moment.duration(
          moment.utc(dateTo).diff(moment.utc(dateFrom), 'minutes'),
          'minutes'
        );
      }
    } else {
      newTimeGran = this.state.activeTimeGran;
    }

    return newTimeGran;
  };

  _checkDateTimeCorrectness = (dateFrom, dateTo) => {
    if (moment(dateFrom).isAfter(dateTo)) {
      return Constants.DATEFROM_AFTER_DATETO_ERROR_MESSAGE;
    }

    if (moment(dateTo).isBefore(dateFrom)) {
      return Constants.DATETO_BEFORE_DATEFROM_ERROR_MESSAGE;
    }

    return null;
  };

  _onChangeDateTime = (key, date1, date2 = null, newTimeGran = null) => {
    let newDateTimeRange = {
      dateTimeFrom: this.state.dateTimeFromFilter,
      dateTimeTo: this.state.dateTimeToFilter,
    };

    switch (key) {
      case 'dateFromFilter':
      case 'timeFromFilter': {
        newDateTimeRange.dateTimeFrom = date1;
        break;
      }
      case 'dateToFilter':
      case 'timeToFilter': {
        newDateTimeRange.dateTimeTo = date1;
        break;
      }
      case 'dateFromAndTo': {
        newDateTimeRange.dateTimeFrom = date1;
        newDateTimeRange.dateTimeTo = date2;
        break;
      }
      default:
        break;
    }

    let dateTimeErrorMessage = this._checkDateTimeCorrectness(
      newDateTimeRange.dateTimeFrom,
      newDateTimeRange.dateTimeTo
    );

    let activeTimeGran = this._getNewTimeGran(
      newDateTimeRange.dateTimeFrom,
      newDateTimeRange.dateTimeTo,
      newTimeGran,
      dateTimeErrorMessage
    );

    this.setState(
      {
        dateTimeFromFilter: newDateTimeRange.dateTimeFrom,
        dateTimeToFilter: newDateTimeRange.dateTimeTo,
        timeRangeMessage: this._getTimeRangeMessage(newDateTimeRange),
        activeTimeGran,
        dateTimeErrorMessage,
      },
      () => {
        this._setQueryValues(
          this.state.dateTimeFromFilter,
          this.state.dateTimeToFilter,
          this.state.selectedTableFilter.displayName
        );
      }
    );
  };

  _getNearestTimeRange = (dateTimeFrom, dateTimeTo, selectedTable) => {
    dateTimeFrom = moment.utc(dateTimeFrom);
    dateTimeTo = moment.utc(dateTimeTo);

    if (this.state.selectedTableFilter != null) {
      selectedTable = selectedTable || this.state.selectedTableFilter;

      let defaultResult = {
        selectedDateTimeFrom: dateTimeFrom,
        selectedDateTimeTo: dateTimeTo,
        nearestDateTimeFrom: dateTimeFrom,
        nearestDateTimeTo: dateTimeTo,
        reductionSpan: null,
        reportName: selectedTable.reportName,
      };

      if (!selectedTable.reportNameByDateRange) {
        return defaultResult;
      }

      let selectedTimeDiff = dateTimeTo.diff(dateTimeFrom);

      let report = Object.entries(selectedTable.reportNameByDateRange).find(
        ([reportName, spanRange]) =>
          (!spanRange.start || moment.duration(spanRange.start) <= selectedTimeDiff) &&
          (!spanRange.end || moment.duration(spanRange.end) > selectedTimeDiff)
      );

      let granularityms = report[1].granularitySec * 1000;

      if (granularityms === 0) {
        defaultResult.reportName = report[0];
        return defaultResult;
      }

      let nearestDateTimeFrom = moment(dateTimeFrom).startOf('day').isSame(dateTimeFrom)
        ? moment.utc(dateTimeFrom.valueOf())
        : moment.utc(dateTimeFrom.valueOf() - (dateTimeFrom.valueOf() % granularityms));

      let remainder = dateTimeTo.valueOf() % granularityms;
      let nearestDateTimeTo = moment.utc(
        dateTimeTo.valueOf() - remainder + (remainder != 0 ? granularityms : 0)
      );

      if (granularityms >= 86400000) {
        nearestDateTimeFrom.startOf('day');
        nearestDateTimeTo = moment.utc(dateTimeTo).startOf('day');
      }

      let reductionSpan = moment
        .duration(report[1].granularitySec, 'seconds')
        .locale('en')
        .humanize();

      return {
        selectedDateTimeFrom: dateTimeFrom,
        selectedDateTimeTo: dateTimeTo,
        nearestDateTimeFrom,
        nearestDateTimeTo,
        reductionSpan,
        reportName: report[0],
      };
    }
  };

  _getTimeRangeMessage = (nearestTimeRange) => {
    if (!nearestTimeRange.reductionSpan) {
      return null;
    }

    return `Will display one data point for each period of ${
      nearestTimeRange.reductionSpan
    } of raw data, from ${nearestTimeRange.nearestDateTimeFrom.format(
      'YYYY-MM-DD HH:mm'
    )} to ${nearestTimeRange.nearestDateTimeTo.format('YYYY-MM-DD HH:mm')}`;
  };

  _getReportForTimeRange = (nearestTimeRange) => nearestTimeRange.reportName;

  _onApplyFilters = () => {
    if (!this.state.selectedTableFilter) {
      this.setState({ isFetching: false });
    } else {
      this.setState({ isFetching: true });

      let timeRange = this._getNearestTimeRange(
        this.state.dateTimeFromFilter,
        this.state.dateTimeToFilter
      );

      getInstrumentData(
        this.props.instrument.SerialNumber,
        this._getReportForTimeRange(timeRange),
        Utils.FeDateAsUtcForBeISOString(timeRange.nearestDateTimeFrom.startOf('minute')),
        Utils.FeDateAsUtcForBeISOString(timeRange.nearestDateTimeTo.startOf('minute'))
      )
        .then((res) => this.receiveInstrumentData(res.body))
        .catch((e) =>
          this.setState({
            isFetching: false,
          })
        );
    }
  };

  receiveInstrumentData = (res) => {
    if (res) {
      const resChart = Object.assign(
        {},
        res.find((config) => config.Name === 'Chart')
      );
      const resNavigationChart = Object.assign(
        {},
        res.find((config) => config.Name === 'NavigationComponent')
      );
      const resTable = Object.assign(
        {},
        res.find((config) => config.Name === 'Table')
      );
      const resMetadata = Object.assign(
        {},
        res.find((config) => config.Name === 'Metadata')
      );
      const resMetadataDataFirstKey = Object.keys(resMetadata.Data)[0];
      const resMetadataData = resMetadata.Data[resMetadataDataFirstKey];
      const correctedTimeSpan = this._getNearestTimeRange(
        this.state.dateTimeFromFilter,
        this.state.dateTimeToFilter
      );

      const exportRawDataReport =
        resTable.Configuration.extraActions &&
        resTable.Configuration.extraActions.exportRawDataReport
          ? resTable.Configuration.extraActions.exportRawDataReport
          : null;

      this.setState(
        {
          chartData: resChart,
          tableData: resTable.Data,
          navigatorData: resNavigationChart.Configuration,
          tableConfig: this._createTableSubreportTemplates(resTable.Configuration.columnsConfig),
          metadata: resMetadataData,
          isFetching: false,
          dateTimeFromFilter: correctedTimeSpan.nearestDateTimeFrom,
          dateTimeToFilter: correctedTimeSpan.nearestDateTimeTo,
          timeRangeMessage: this._getTimeRangeMessage(correctedTimeSpan),
          currentReportName: this._getReportForTimeRange(correctedTimeSpan),
          exportRawDataReport: exportRawDataReport,
          extraActionsButtons: this._extraActionsButtons(resTable.Configuration.extraActions),
        },
        () => {
          this._setQueryValues(
            this.state.dateTimeFromFilter,
            this.state.dateTimeToFilter,
            this.state.selectedTableFilter.displayName
          );
          this._saveDateTime();
        }
      );
    } else {
      this.setState({
        isFetching: false,
      });
    }
  };

  _saveDateTime = () => {
    let startType = 'dateTime';
    let endType = 'dateTime';

    let newDateFrom = moment.utc(this.state.dateTimeFromFilter.format('YYYY-MM-DDTHH:mm:ss'));
    let newDateTo = moment.utc(this.state.dateTimeToFilter.format('YYYY-MM-DDTHH:mm:ss'));
    let reportName = this.props.selectedTable.displayName;

    Store.dispatch(
      setGlobalDateTime({
        type: SET_GLOBAL_DATETIME,
        startDate: newDateFrom.format(),
        endDate: newDateTo.format(),
        startType: startType,
        endType: endType,
        setByReportName: reportName,
      })
    );
  };

  _extraActionsButtons = (extraActions) => {
    if (extraActions && extraActions.exportRawDataReport)
      return [
        <Button
          variant="contained"
          className="u-mh-full"
          data-qa="qa-table-exportwithrawdata"
          color="primary"
          id="rawDataButton"
        >
          Export With Raw Data
        </Button>,
      ];
  };

  _createTableSubreportTemplates = (colConfigs) => {
    return colConfigs.map((colConfig) => {
      let type = colConfig.type;
      if (type && type.startsWith('SubreportDialog')) {
        colConfig.type = 'markup';
        colConfig.markup = (el, col, elIndex, colIndex) => {
          return (
            <IconButton
              size="large"
              onClick={this._onShowSubreport(el, col.arguments)}
              style={{
                width: 'auto',
                height: 'auto',
                padding: 0,
              }}
            >
              <ChartIcon />
            </IconButton>
          );
        };
      }
      return colConfig;
    });
  };

  _onShowSubreport = (el, args) => {
    return () => {
      let argsObj = args.reduce((acc, cv) => {
        acc[cv.keyName] = cv.value || el[cv.valueName];
        return acc;
      }, {});
      let subreportConfig = Object.assign({}, this.state.subreportConfig, {
        dialogSubreport: { open: true, args: argsObj, onClose: this._onHideSubreport },
      });

      this.setState({
        subreportConfig,
      });
    };
  };

  _onHideSubreport = () => {
    let subreportConfig = Object.assign({}, this.state.subreportConfig, {
      dialogSubreport: { open: false, args: null },
    });

    this.setState({
      subreportConfig,
    });
  };
}

InstrumentTelemetryContainer.propTypes = {
  selectedTable: PropTypes.object,
};

InstrumentTelemetry.defaultProps = {
  selectedTable: null,
};

const mapStateToProps = (state) => ({
  globalDateTime: state.globalDateTime ? state.globalDateTime : null,
});

export default withRouter(connect(mapStateToProps)(InstrumentTelemetryContainer));
